<db-dialog-wrapper [dialog]="this" [width]="leaveWorkspace ? '488px': '700px'" [canClose]="!loading" [hasCloseButton]="!loading" [canCloseByBackdrop]="!loading">
  <div class="db-leave-remove-workspace-dialog__wrap">
    <form [formGroup]="workspaceForm" (ngSubmit)="submit()">
      <div class="db-leave-remove-workspace-dialog__content">
      <h3 [innerHTML]="(leaveWorkspace ? 'text_leaveWorkspace' : 'text_removeUser') | dbText"></h3>
      <p *ngIf="leaveWorkspace" [innerHTML]="'text_leaveWorkspaceConsequence' | dbText:{ workspaceName: workspaceName }"></p>
      <p *ngIf="!leaveWorkspace" [innerHTML]="'text_removeUserQuestion' | dbText: {user: user?.email}"></p>
      <p [innerHTML]="(leaveWorkspace ? 'text_leaveWorkspaceQuestion' : 'text_removeUserConsequence') | dbText: { workspaceName: workspaceName }"></p>
      <div class="db-leave-remove-workspace-dialog__last-question">
        <p [innerHTML]="(leaveWorkspace ? 'text_leaveWorkspaceTypePassword' : 'text_removeUserTypePassword') | dbText"></p>
        <div class="db-leave-remove-workspace-dialog__input-group">
          <input *ngIf="!showPassword" maxlength="128" class="db-fc-input db-leave-remove-workspace-dialog__input" type="password" placeholder="Password" formControlName="password" [ngClass]="{'db-button_disabled': loading, 'db-leave-remove-workspace-dialog__input-invalid': serverErrors}"/>
          <input *ngIf="showPassword"  maxlength="128" class="db-fc-input db-leave-remove-workspace-dialog__input" type="text" placeholder="Password" formControlName="password" [ngClass]="{'db-button_disabled': loading, 'db-leave-remove-workspace-dialog__input-invalid': serverErrors}" />
          <i class="db-icon db-icon-eye" *ngIf="!showPassword" (click)="togglePassword()" title="Show password"></i>
          <i class="db-icon db-icon-eye-hide" *ngIf="showPassword" (click)="togglePassword()" title="Hide password"></i>
        </div>
      </div>
      <div class="db-server-error-wrap">
        <div>{{serverErrors?.message}}</div>
      </div>
        <div *ngIf="!leaveWorkspace" class="db-leave-remove-workspace-dialog__confirm">
          <p [innerHTML]="'text_removeUserWPAdminNotifier' | dbText: {user: user?.email}"></p>
          <div class="checkbox">
            <input type="checkbox" id="coding" value="true" formControlName="confirm" (change)="confirmWPAdminNotifier($event)">
            <label for="coding" [innerHTML]="'text_removeUserWPAdminCheck' | dbText"></label>
          </div>
        </div>
      <div class="db-leave-remove-workspace-dialog__buttons-wrap">
        <a class="db-button cancel" [ngClass]="{'db-button_disabled': loading}" (click)="close()">
          <span>{{'text_cancel' | dbText}}</span>
        </a>
        <a class="db-button db-button_lg db-button_danger" [ngClass]="{'db-button_disabled': !workspaceForm.valid || loading}" (click)="submit()">
          <span *ngIf="!loading" [innerHTML]="(leaveWorkspace ? 'text_leaveWorkspace' : 'text_yesRemove') | dbText"></span>
          <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
        </a>
      </div>
    </div>
    </form>
  </div>
</db-dialog-wrapper>
